module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-text-right uk-margin-medium-bottom",
    attrs: {
      "uk-toggle": "mode: media; media: @m"
    }
  }, [_c('span', {
    staticClass: "tm-view-button"
  }, [_vm._v("\n        Вид: "), _c('a', {
    attrs: {
      "uk-toggle": "target: #card_view; cls: uk-child-width-1-4@m tm-grid;"
    }
  }, [(_vm.view == 'grid') ? _c('span', {
    attrs: {
      "uk-icon": "icon: list"
    },
    on: {
      "click": function($event) {
        return _vm.changeView()
      }
    }
  }) : _c('span', {
    attrs: {
      "uk-icon": "icon: grid;ratio: 1.5;"
    },
    on: {
      "click": function($event) {
        return _vm.changeView()
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6889ac06","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/GroupView.vue
// module id = 190
// module chunks = 0